// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.1/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-dropdown-item[data-v-b8fc5304]{white-space:normal;padding-top:.5rem;padding-bottom:.5rem}.help-item-icon[data-v-b8fc5304]{box-sizing:content-box;width:1.5rem;height:1.5rem;padding:.55rem;margin-right:.85rem;background-color:var(--header-help-dropdown-icon-background-color);border-radius:4px;color:var(--header-help-dropdown-icon-color);font-size:1.25rem}.external-link-icon[data-v-b8fc5304]{font-size:.75rem}", ""]);
// Exports
module.exports = exports;
